import { render } from "./attributes.vue?vue&type=template&id=6fdfd9a2"
import script from "./attributes.vue?vue&type=script&lang=js"
export * from "./attributes.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__